module.exports = __webpack_public_path__ + "static/media/tutorial_04_no_dots.f534c114.png";